import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';
import { FrequencyThermometerDetalhe } from '../dashboard/types/consolidationTermometroFrequencia';

async function getTermometroFrequenciaAluno(id): Promise<FrequencyThermometerDetalhe> {
  const api = await getApi();
  const { data } = await api.get<FrequencyThermometerDetalhe>(`/termometro/frequencia/detalhes/?id=${id}`, {});

  return data;
}

type QueryFnType = typeof getTermometroFrequenciaAluno;

function useTermometroFrequenciaAluno(id) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['termometro-frequencia-detalhes', id],
    queryFn: () => getTermometroFrequenciaAluno(id),
  });
}

export { getTermometroFrequenciaAluno, useTermometroFrequenciaAluno };
